// Contato de suporte ÚNICO do Hub (PO1-3509, épico PO1-3504). Decisão do
// Rodrigo em 18/10/2026: `suporte@everlogtms.com.br` cai no SUP do Jira. Toda
// tela que mostra o suporte lê daqui, em vez de cravar o endereço.
export const SUPORTE_EMAIL = "suporte@everlogtms.com.br";
export const SUPORTE_PORTAL = "https://suporte.everlog.tech";
export const SUPORTE_PORTAL_ROTULO = "suporte.everlog.tech";
